const FinanicStatics = () => import('@/vuepage/statics-manage/FinanicStatics');
const CompreDataStatics = () => import('@/vuepage/statics-manage/CompreDataStatics');

export default [{
		path: '/finanic-statics',
		component: FinanicStatics,
		meta: [{
				name: '数据统计'
			},
			{
				name: '财务指标',
				activeRoute: '/finanic-statics'
			}
		]
	},
	{
		path: '/compre-data-statics',
		component: CompreDataStatics,
		meta: [{
				name: '数据统计'
			},
			{
				name: '综合数据分析',
				activeRoute: '/compre-data-statics'
			}
		]
	},
];